const isNumericString = (value: string) =>
  typeof value === 'string' && /^[0-9]+$/.test(value);

export const checkKeyForNumericString = (optionArray: any) =>
  optionArray
    .map((obj: any) => {
      if (obj.hasOwnProperty('Order')) {
        const value = obj['Order'];
        if (typeof value === 'string') {
          return isNumericString(value);
        } else return;
      }
    })
    .filter((item: any) => item !== undefined);

export const checkifEmptyItemName = (optionArray: any) =>
  optionArray
    .map((obj: any) => {
      if (!obj.ItemLabel.length) return obj;
      else return;
    })
    .filter((item: any) => item !== undefined);

export const checkifEmptyItemLabel = (optionArray: any) =>
  optionArray
    .map((obj: any) => {
      if (!obj.ItemName.length) return obj;
      else return;
    })
    .filter((item: any) => item !== undefined);
